@if (data) {
<div id="contactenos" class="container">
  <div class="row justify-content-center py-5">
    <div class="col-lg-7 mb-4 mb-lg-0">
      @if (data.icon) {
      <span class="d-lg-none material-symbols-outlined mat-icon-size-52 custom-negative-margin primary-900">{{data.icon}}</span>
      }
      @if (data.titulo) {
      <p class="primary-900 tab-ancla mb-2">{{data.titulo}}</p>
      }
      <h2 class="primary-900 mb-2">{{data.pregunta}}</h2>
      <p class="p1-regular primary-900" [innerHTML]="data.subtitulo"></p>
    </div>
    <div class="col-lg-5 d-flex flex-column justify-content-end align-items-lg-end">
      <div class="d-lg-flex flex-column align-items-lg-center">
        @if (data.icon) {
        <span class="d-none d-lg-block material-symbols-outlined mat-icon-size-52 primary-900 mb-2"
          title="{{data.icon}}">{{data.icon}}</span>
        }
        <a [href]="data.btnRuta" target="_blank" class="btn btn-secondary px-5 mb-lg-1 mt-lg-0 custom-margin-top"
          title="{{data.btnText}}">{{data.btnText}}</a>
      </div>
    </div>
  </div>
</div>
}